/*
 *  servicebezogene Konstanten
 */
export const ServiceConstants = Object.freeze({
  SERVICE_NOT_AVAILABLE: 'SERVICE_NOT_AVAILABLE',
  VALUE_SEPARATOR: ';',
  ITEMS_PER_PAGE: 20
});
